const currencyFullNames = {
  USD: 'United States Dollar (USD)',
  EUR: 'Euro (EUR)',
  EUR_PT: 'Euro (Portugal) (EUR)',
  EUR_DE: 'Euro (Germany) (EUR)',
  EUR_GR: 'Euro (Greece) (EUR)',
  EUR_FR: 'Euro (France) (EUR)',
  EUR_IT: 'Euro (Italy) (EUR)',
  EUR_ES: 'Euro (Spain) (EUR)',
  EUR_NL: 'Euro (Netherlands) (EUR)',
  EUR_BE: 'Euro (Belgium) (EUR)',
  EUR_AT: 'Euro (Austria) (EUR)',
  EUR_IE: 'Euro (Ireland) (EUR)',
  EUR_LU: 'Euro (Luxembourg) (EUR)',
  EUR_FI: 'Euro (Finland) (EUR)',
  EUR_SK: 'Euro (Slovakia) (EUR)',
  EUR_SI: 'Euro (Slovenia) (EUR)',
  EUR_EE: 'Euro (Estonia) (EUR)',
  EUR_LV: 'Euro (Latvia) (EUR)',
  EUR_LT: 'Euro (Lithuania) (EUR)',
  EUR_CY: 'Euro (Cyprus) (EUR)',
  EUR_MT: 'Euro (Malta) (EUR)',
  GBP: 'British Pound (GBP)',
  JPY: 'Japanese Yen (JPY)',
  CNY: 'Chinese Yuan (CNY)',
  AUD: 'Australian Dollar (AUD)',
  CAD: 'Canadian Dollar (CAD)',
  CHF: 'Swiss Franc (CHF)',
  SEK: 'Swedish Krona (SEK)',
  DKK: 'Danish Krone (DKK)',
  NOK: 'Norwegian Krone (NOK)',
  NZD: 'New Zealand Dollar (NZD)',
  SGD: 'Singapore Dollar (SGD)',
  HKD: 'Hong Kong Dollar (HKD)',
  CZK: 'Czech Koruna (CZK)',
  HUF: 'Hungarian Forint (HUF)',
  RON: 'Romanian Leu (RON)',
  BGN: 'Bulgarian Lev (BGN)',
  HRK: 'Croatian Kuna (HRK)',
  INR: 'Indian Rupee (INR)',
  KRW: 'South Korean Won (KRW)',
  THB: 'Thai Baht (THB)',
  VND: 'Vietnamese Dong (VND)',
  MYR: 'Malaysian Ringgit (MYR)',
  PHP: 'Philippine Peso (PHP)',
  BRL: 'Brazilian Real (BRL)',
  ARS: 'Argentine Peso (ARS)',
  CLP: 'Chilean Peso (CLP)',
  COP: 'Colombian Peso (COP)',
  PEN: 'Peruvian Sol (PEN)',
  ZAR: 'South African Rand (ZAR)',
  NGN: 'Nigerian Naira (NGN)',
  EGP: 'Egyptian Pound (EGP)',
  KES: 'Kenyan Shilling (KES)',
  GHS: 'Ghanaian Cedi (GHS)',
  AED: 'United Arab Emirates Dirham (AED)',
  SAR: 'Saudi Riyal (SAR)',
  QAR: 'Qatari Riyal (QAR)',
  ILS: 'Israeli Shekel (ILS)',
  TRY: 'Turkish Lira (TRY)',
  '...': 'Select Currency',
};

export default currencyFullNames;
